(function (angular) {
  "use strict";

  angular.module("Toyota.Directives").directive("tyShowIfMissingSrc", [
    "$http",
    "$q",
    function ($http, $q) {
      return {
        scope: {},
        link: function (scope, $element, $attrs) {
          var url = $attrs.tyShowIfMissingSrc;
          var style = $attrs.tyShowIfMissingSrcStyle;
          $element.addClass("ng-hide");

          $http.head(url).catch(function () {
            $element.removeClass("ng-hide");
            if (style) {
              $element.attr("style", style);
            }

            return $q.resolve();
          });
        },
      };
    },
  ]);
})(window.angular);
